export default {
      id: "icon-phone-classic-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-phone-classic",
      toString: function () {
        return this.url;
      }
    }